// removed by extract-text-webpack-plugin
module.exports = {"projects":"CommercialProjects__projects__QTyXa","commercialProjectHeading":"CommercialProjects__commercialProjectHeading__2J7IB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/CommercialProjects/CommercialProjects.css
// module id = 303
// module chunks = 0